import React from 'react';
import { Col, Container, Row, Image } from 'react-bootstrap';
import "./style.css";

function Page(props) {

    const { state } = props;
    
    return (
        <footer id="footer-page" style={{ backgroundColor: (state.transparent) ? "transparent" : "#091636" }}>
            <Container>
                <Row>
                    <Col xs={12} md={6}>
                        <Image src={"../assets/logo_white_small.png"} />
                    </Col>
                    <Col xs={12} md={6}>
                        <p className="copyright">© Copyright Todos los derechos reservados, ADOCINE {new Date().getFullYear()}.</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Page;